import { Component } from '@angular/core';
import { Injectable,Inject } from '@angular/core';

@Component({
    selector: 'app-validate-editprofile',
    templateUrl: './validate-editprofile.component.html',
    styleUrls: ['./validate-editprofile.component.css'],
    standalone: false
})

@Injectable()
export class ValidateEditprofileComponent {
  "maincontrol":string;
  "officecontrol":string;
  "telecontrolcontrol":string;
  "day":string;
  constructor( @Inject('') maincontrol: string, @Inject('') officecontrol : string , @Inject('') telecontrolcontrol : string , @Inject('') day : string)
  {
    this.maincontrol =maincontrol;
    this.officecontrol = officecontrol;
    this.telecontrolcontrol= telecontrolcontrol;
    this.day= day;
  }
 
}
